function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState: uS,
  useEffect: uE,
  useRef: uR
} = React;
const D = window.JDC_DATA || {};

// ── Icons ─────────────────────────────────────────────────────
const Sparkle = ({
  className = ''
}) => /*#__PURE__*/React.createElement("svg", {
  className: `sparkle ${className}`,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0l2 10 10 2-10 2-2 10-2-10-10-2 10-2z"
}));
const ArrowR = ({
  size = 14
}) => /*#__PURE__*/React.createElement("svg", {
  className: "arrow",
  width: size,
  height: size * 10 / 14,
  viewBox: "0 0 14 10",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 5h12M8.5 1L13 5l-4.5 4",
  strokeLinecap: "square"
}));
const ArrowConnector = () => /*#__PURE__*/React.createElement("svg", {
  className: "howto__arrow",
  width: "40",
  height: "20",
  viewBox: "0 0 40 20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 10h34M30 4l6 6-6 6",
  strokeLinecap: "square"
}));
const IconUser = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "8",
  r: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 21c0-4 3.5-7 8-7s8 3 8 7"
}));
const IconBag = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 8h12l-1 12H7zM9 8V5a3 3 0 1 1 6 0v3"
}));
const IconGift = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "9",
  width: "18",
  height: "11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 13h18M12 9v11M9 9c0-3 6-3 3-6-3 3 3 3 0 6"
}));
const IconTruck = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 7h10v10H2zM12 11h6l3 4v2h-9z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6",
  cy: "18",
  r: "1.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "17",
  cy: "18",
  r: "1.6"
}));
const IconCake = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 12h16v9H4zM6 12V8h12v4M9 8V5M12 8V4M15 8V5"
}));
const IconCrown = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 18l2-10 4 4 3-7 3 7 4-4 2 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 21h18"
}));
const IconCal = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "5",
  width: "18",
  height: "16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10h18M8 3v4M16 3v4"
}));
const IconUsers = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 19c0-3 3-5 6-5s6 2 6 5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "17",
  cy: "6",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 12c4 0 6 2 6 5"
}));
const IconStar = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 3l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"
}));
const IconReview = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 5h16v11H10l-5 4v-4H4z"
}));
const IconTag = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 13L11 5h8v8l-8 8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "15",
  cy: "9",
  r: "1.5"
}));
const IconLock = () => /*#__PURE__*/React.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "11",
  width: "16",
  height: "11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 11V7a4 4 0 1 1 8 0v4"
}));
const IconCheck = ({
  size = 14
}) => /*#__PURE__*/React.createElement("svg", {
  className: "tier__check",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 12l5 5L20 7",
  strokeLinecap: "square"
}));
const IconCopy = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "8",
  y: "8",
  width: "12",
  height: "12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 16V4h12"
}));
const IconIg = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "17.5",
  cy: "6.5",
  r: "0.8",
  fill: "currentColor"
}));
const IconTt = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 3v12.5a3.5 3.5 0 1 1-3.5-3.5M14 3c0 3 2.5 5 5 5"
}));
const IconWa = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 21l1.6-5A8.5 8.5 0 1 1 8 19.4L3 21z"
}));

// ── Animated counter ─────────────────────────────────────────
function Counter({
  to,
  duration = 1600,
  start = 0
}) {
  const [val, setVal] = uS(start);
  const ref = uR(null);
  const started = uR(false);
  uE(() => {
    const el = ref.current;
    if (!el) { setVal(to); return; }
    started.current = false; // Reset on each `to` change so LL-updated pts animates
    let cancelled = false, raf = 0, timer = 0;
    const runAnimation = () => {
      if (started.current) return;
      started.current = true;
      const t0 = performance.now();
      const tick = t => {
        if (cancelled) return;
        const p = Math.min(1, (t - t0) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        setVal(Math.round(start + (to - start) * eased));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) runAnimation(); });
    }, { threshold: 0.1 });
    io.observe(el);
    // Fallback: if already visible or IO doesn't fire, animate after short delay
    timer = setTimeout(runAnimation, 300);
    return () => { cancelled = true; io.disconnect(); clearTimeout(timer); if (raf) cancelAnimationFrame(raf); };
  }, [to]);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref
  }, val.toLocaleString('es-CO'));
}

// ── Scroll-reveal ─────────────────────────────────────────────
function Reveal({
  as: Tag = 'div',
  delay = 0,
  className = '',
  children,
  ...rest
}) {
  const ref = uR(null);
  uE(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) el.classList.add('is-visible');
      });
    }, {
      threshold: 0.15
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: ref,
    className: `reveal ${delay ? `reveal--delay-${delay}` : ''} ${className}`
  }, rest), children);
}

// ── HERO ─────────────────────────────────────────────────────
function Hero({
  pts
}) {
  return /*#__PURE__*/React.createElement("section", {
    className: "hero"
  }, /*#__PURE__*/React.createElement(Sparkle, {
    className: "hero__star"
  }), /*#__PURE__*/React.createElement(Sparkle, {
    className: "hero__star"
  }), /*#__PURE__*/React.createElement(Sparkle, {
    className: "hero__star"
  }), /*#__PURE__*/React.createElement(Sparkle, {
    className: "hero__star"
  }), /*#__PURE__*/React.createElement(Sparkle, {
    className: "hero__star"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hero__edge hero__edge--tl"
  }, "JDC \xB7 MDE", /*#__PURE__*/React.createElement("br", null), "EST. MMXXIV"), /*#__PURE__*/React.createElement("div", {
    className: "hero__edge hero__edge--tr"
  }, "PROGRAMA", /*#__PURE__*/React.createElement("br", null), "DE MEMBRES\xCDA"), /*#__PURE__*/React.createElement("div", {
    className: "hero__edge hero__edge--bl"
  }, "EDIT \xB7 001 / 12"), /*#__PURE__*/React.createElement("div", {
    className: "hero__edge hero__edge--br"
  }, "SCROLL \u2193"), /*#__PURE__*/React.createElement("div", {
    className: "hero__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero__badge pill"
  }, /*#__PURE__*/React.createElement(Sparkle, null), "JDC Club", /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement("h1", {
    className: "hero__headline"
  }, /*#__PURE__*/React.createElement("span", {
    className: "word word--accent"
  }, "Compra"), ' ', /*#__PURE__*/React.createElement("span", {
    className: "word"
  }, "menos."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "word word--solid"
  }, "Gana"), ' ', /*#__PURE__*/React.createElement("span", {
    className: "word word--accent-solid"
  }, "m\xE1s.")), /*#__PURE__*/React.createElement("p", {
    className: "hero__sub"
  }, "Bienvenido al JDC Club — el programa que creamos para nuestros clientes más fieles. Acumula puntos en cada compra, sube de nivel y canjea recompensas que de verdad valen la pena. Hecho con cariño, para ti."), /*#__PURE__*/React.createElement("div", {
    className: "hero__points"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero__points-num",
    "data-jdc-pts-hero": true
  }, /*#__PURE__*/React.createElement(Counter, {
    to: D.loggedIn ? pts : 80000,
    duration: 1800
  })), /*#__PURE__*/React.createElement("div", {
    className: "hero__points-label"
  }, D.loggedIn ? ("Puntos \xB7 Nivel " + tES(D.tier || 'BRONZE')) : "Puntos de bienvenida al unirte gratis")),
  !D.loggedIn && /*#__PURE__*/React.createElement("div", {
    className: "hero__ctas"
  }, /*#__PURE__*/React.createElement("a", {
    href: D.registerUrl,
    className: "btn btn--accent"
  }, "\xDAnete gratis ", /*#__PURE__*/React.createElement(ArrowR, null)), /*#__PURE__*/React.createElement("a", {
    href: D.loginUrl,
    className: "btn btn--ghost"
  }, "Iniciar sesi\xF3n")),
  D.loggedIn && /*#__PURE__*/React.createElement("div", {
    className: "hero__ctas"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#canjear",
    className: "btn btn--accent",
    onClick: function(e){ e.preventDefault(); var el = document.getElementById('canjear'); if(el) el.scrollIntoView({behavior:'smooth'}); }
  }, "Canjear puntos ", /*#__PURE__*/React.createElement(ArrowR, null)))));
}

// ── CÓMO FUNCIONA ────────────────────────────────────────────
function HowTo() {
  const steps = [{
    n: '01',
    icon: /*#__PURE__*/React.createElement(IconUser, null),
    title: '\xDAnete gratis',
    desc: /*#__PURE__*/React.createElement(React.Fragment, null, "Crea tu cuenta JDC y recibe ", /*#__PURE__*/React.createElement("strong", null, "80.000 puntos"), " de bienvenida al instante.")
  }, {
    n: '02',
    icon: /*#__PURE__*/React.createElement(IconBag, null),
    title: 'Acumula puntos',
    desc: /*#__PURE__*/React.createElement(React.Fragment, null, "Suma con cada compra, rese\xF1a, cumplea\xF1os y cuando traes amigos. ", /*#__PURE__*/React.createElement("strong", null, "Los puntos por compra se acreditan a los 21 d\xEDas."))
  }, {
    n: '03',
    icon: /*#__PURE__*/React.createElement(IconTag, null),
    title: 'Canjea y disfruta',
    desc: /*#__PURE__*/React.createElement(React.Fragment, null, "Cambia tus puntos por descuentos exclusivos en tus marcas favoritas.")
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "C\xF3mo"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "funciona"))), /*#__PURE__*/React.createElement("div", {
    className: "howto__grid"
  }, steps.map((s, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: s.n
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "howto__card",
    delay: i + 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "howto__num"
  }, s.n), /*#__PURE__*/React.createElement("div", {
    className: "howto__icon"
  }, s.icon), /*#__PURE__*/React.createElement("div", {
    className: "howto__title"
  }, s.title), /*#__PURE__*/React.createElement("div", {
    className: "howto__desc"
  }, s.desc)), i < steps.length - 1 && /*#__PURE__*/React.createElement(ArrowConnector, null))))));
}

// ── DASHBOARD ─────────────────────────────────────────────────
function Dashboard({
  pts,
  tier: tierProp
}) {
  const barRef = uR(null);
  const cardRef = uR(null);
  const tier = tierProp || D.tier || 'BRONZE';
  const nextTier = D.nextTier || 'Plata';
  const spentPct = D.spentPct || 0;
  const nextAmount = (D.nextAmount || 300000).toLocaleString('es-CO');
  const spentFmt = (D.spent || 0).toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  });
  uE(() => {
    const el = cardRef.current;
    if (!el) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && barRef.current) barRef.current.style.width = spentPct + '%';
      });
    }, {
      threshold: 0.4
    });
    io.observe(el);
    return () => io.disconnect();
  }, [spentPct]);
  if (!D.loggedIn) {
    return /*#__PURE__*/React.createElement("section", {
      className: "dashboard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "section__head"
    }, /*#__PURE__*/React.createElement(Reveal, {
      className: "sparkle-row"
    }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
      as: "div",
      className: "eyebrow"
    }, "Tu cuenta"), /*#__PURE__*/React.createElement(Reveal, {
      as: "h2"
    }, "Tu estado", /*#__PURE__*/React.createElement("br", null), "en ", /*#__PURE__*/React.createElement("span", {
      className: "accent"
    }, "tiempo real"))), /*#__PURE__*/React.createElement(Reveal, {
      className: "dashboard__card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard__hello"
    }, "\xDAnete al ", /*#__PURE__*/React.createElement("b", null, "Club JDC"), " para ver tus puntos"), /*#__PURE__*/React.createElement("div", {
      className: "dashboard__num",
      style: {
        fontSize: '64px',
        color: 'var(--gray-2)'
      }
    }, "\u2014"), /*#__PURE__*/React.createElement("div", {
      className: "dashboard__num-label"
    }, "Inicia sesi\xF3n para ver tu saldo"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        gap: '16px',
        marginTop: '16px'
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: D.loginUrl,
      className: "btn btn--dark"
    }, "Iniciar sesi\xF3n ", /*#__PURE__*/React.createElement(ArrowR, null)), /*#__PURE__*/React.createElement("a", {
      href: D.registerUrl,
      className: "btn btn--ghost"
    }, "Crear cuenta ", /*#__PURE__*/React.createElement(ArrowR, null)))));
  }
  return /*#__PURE__*/React.createElement("section", {
    className: "dashboard",
    ref: cardRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "div",
    className: "eyebrow"
  }, "Tu cuenta"), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, "Tu estado", /*#__PURE__*/React.createElement("br", null), "en ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "tiempo real"))), /*#__PURE__*/React.createElement(Reveal, {
    className: "dashboard__card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard__corner dashboard__corner--tl"
  }, "ACTIVE \xB7 0001"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__corner dashboard__corner--tr"
  }, "JDC \xB7 MMXXIV"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__corner dashboard__corner--bl"
  }, "MIEMBRO MDE"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__corner dashboard__corner--br",
    id: "jdc-v2-sync-time"
  }, "SYNC --:--"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__hello"
  }, "Hola, ", /*#__PURE__*/React.createElement("b", null, D.name)), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__num",
    "data-jdc-pts-dash": true
  }, /*#__PURE__*/React.createElement(Counter, {
    to: pts,
    duration: 1800
  })), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__num-label"
  }, "Puntos disponibles"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__tier-pill"
  }, "NIVEL ", /*#__PURE__*/React.createElement("span", {
    className: "tier",
    "data-jdc-tier-label": true
  }, tES(tier))), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard__progress-meta"
  }, /*#__PURE__*/React.createElement("span", null, spentFmt, " gastados"), tier !== 'GOLD' ? /*#__PURE__*/React.createElement("span", {
    className: "right"
  }, "$", nextAmount, " para ", nextTier) : /*#__PURE__*/React.createElement("span", {
    className: "right",
    style: {
      color: 'var(--gold)'
    }
  }, "\u2726 \xA1Lleg\xF3 al tope, campe\xF3n!")), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__progress-track"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard__progress-bar",
    ref: barRef
  })), /*#__PURE__*/React.createElement("div", {
    className: "dashboard__progress-foot"
  }, D.orders, " ", D.orders === 1 ? 'pedido' : 'pedidos', " en tu historial"))));
}

// ── BENEFICIOS ───────────────────────────────────────────────
function Benefits() {
  const items = [{icon:/*#__PURE__*/React.createElement(IconTag,null),title:'Descuentos exclusivos',desc:'Cambia tus puntos por descuento al canjear'},{icon:/*#__PURE__*/React.createElement(IconCake,null),title:'Regalito de cumplea\xF1os',desc:'Hasta 660.000 puntos de regalo en tu d\xEDa'},{icon:/*#__PURE__*/React.createElement(IconCrown,null),title:'Niveles VIP',desc:'M\xE1s beneficios mientras m\xE1s subes de nivel'},{icon:/*#__PURE__*/React.createElement(IconStar,null),title:'Bono de bienvenida Oro',desc:'Puntos de regalo al alcanzar el nivel Oro'},{icon:/*#__PURE__*/React.createElement(IconUsers,null),title:'Trae a tus amigos',desc:'Gana 330.000 pts por cada amigo que compre'},{icon:/*#__PURE__*/React.createElement(IconGift,null),title:'Recompensas exclusivas',desc:'Beneficios solo para miembros del club'}];
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      background: 'var(--bg-soft)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Beneficios"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "del club"))), /*#__PURE__*/React.createElement("div", {
    className: "benefits__grid"
  }, items.map((b, i) => /*#__PURE__*/React.createElement(Reveal, {
    key: i,
    className: "benefit",
    delay: i % 6 + 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "benefit__icon"
  }, b.icon), /*#__PURE__*/React.createElement("div", {
    className: "benefit__title"
  }, b.title), /*#__PURE__*/React.createElement("div", {
    className: "benefit__desc"
  }, b.desc))))));
}

// ── GANAR PUNTOS ─────────────────────────────────────────────
function Earn() {
  const [completed, setCompleted] = uS({});
  const [bdaySaved, setBdaySaved] = uS(false);
  const [bdayVal, setBdayVal] = uS('');

  // Detecta si el cliente ya tiene cumpleaños guardado en LoyaltyLion
  uE(() => {
    let n = 0;
    const iv = setInterval(() => {
      n++;
      const c = window.loyaltylion && window.loyaltylion.customer;
      if (c && c.birthday) { setBdaySaved(true); clearInterval(iv); }
      if (n >= 20) clearInterval(iv);
    }, 500);
    return () => clearInterval(iv);
  }, []);

  function saveBirthday() {
    // Lee la fecha directo del input del DOM (fuente de verdad, sin riesgo de timing de estado)
    const el = document.querySelector('.earn__bday-input');
    const val = (el && el.value) || bdayVal;
    if (!val) return;
    // Es permanente (set-once en LoyaltyLion): confirmar para evitar errores irreversibles
    if (!window.confirm('Tu cumpleaños quedará guardado y no podrás cambiarlo. ¿Confirmas ' + val.split('-').reverse().join('/') + '?')) return;
    try {
      const ll = window.loyaltylion;
      if (ll && ll.api && ll.api.customers && ll.api.customers.setBirthday) {
        ll.api.customers.setBirthday({ birthday: val })
          .then(function (res) {
            if (res && res.birthday) setBdaySaved(true);
          })
          .catch(function () {});
      }
    } catch (e) {}
  }

  const acts = [
    {icon:/*#__PURE__*/React.createElement(IconBag,null),title:'Haz una compra',sub:'1 punto por $1 — hasta 2x en Oro',pts:'1',unit:'PT / $1',action:'cart',cta:'Ir a comprar'},
    {icon:/*#__PURE__*/React.createElement(IconUser,null),title:'Únete al programa',sub:'Bono único al registrarte',pts:'80.000',unit:'PTS DE BONO'},
    {icon:/*#__PURE__*/React.createElement(IconCake,null),title:'Feliz cumpleaños',sub:'Registra tu fecha y recibe tu bono',pts:'BONO',unit:'EN TU CUMPLE',birthday:true},
    {icon:/*#__PURE__*/React.createElement(IconUsers,null),title:'Invita a un amigo',sub:'Gana 330.000 pts cuando tu amigo compre $100.000+ — él recibe 10% off',pts:'330.000',unit:'POR REFERIDO',action:'referir',cta:'Invitar amigos'},
    {icon:/*#__PURE__*/React.createElement(IconStar,null),title:'Deja una reseña con foto',sub:'En el producto que compraste',pts:'40.000',unit:'PUNTOS'},
    {icon:/*#__PURE__*/React.createElement(IconStar,null),title:'Síguenos en Instagram',sub:'@jdcshop_premium',pts:'5.000',unit:'PUNTOS',ruleId:'251321',url:'https://instagram.com/jdcshop_premium'},
    {icon:/*#__PURE__*/React.createElement(IconStar,null),title:'Síguenos en TikTok',sub:'@jdc_shop',pts:'5.000',unit:'PUNTOS',ruleId:'251322',url:'https://tiktok.com/@jdc_shop'}
  ];

  function doAction(action) {
    if (action === 'cart') {
      fetch('/cart.js').then(r => r.json()).then(c => {
        window.location.href = (c && c.item_count > 0) ? '/cart' : '/collections/all';
      }).catch(() => { window.location.href = '/cart'; });
    } else if (action === 'referir') {
      const el = document.getElementById('referir');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Lee del widget de LoyaltyLion qué misiones ya están completadas
  function checkCompleted() {
    const map = {};
    document.querySelectorAll('[data-lion-rules-list] [data-rule-id]').forEach(function(it){
      const id = it.getAttribute('data-rule-id');
      const cls = it.className || '';
      if (cls.indexOf('completed-forever') !== -1 || cls.indexOf('completed') !== -1 || cls.indexOf('actionable') === -1) {
        map[id] = true;
      }
    });
    return map;
  }

  uE(() => {
    let n = 0;
    const iv = setInterval(() => {
      n++;
      const m = checkCompleted();
      if (Object.keys(m).length) setCompleted(prev => Object.assign({}, prev, m));
      if (n >= 20) clearInterval(iv);
    }, 500);
    return () => clearInterval(iv);
  }, []);

  function completeRule(ruleId, fallbackUrl) {
    function clickLL() {
      const sels = [
        '[data-lion-rules-list] [data-rule-id="' + ruleId + '"] button',
        '[data-lion-rules-list] .lion-rule-item[data-rule-id="' + ruleId + '"]'
      ];
      for (let i = 0; i < sels.length; i++) {
        const el = document.querySelector(sels[i]);
        if (el) { el.click(); return true; }
      }
      return false;
    }
    const clicked = clickLL();
    if (!clicked && fallbackUrl) window.open(fallbackUrl, '_blank');
    // Tras el clic, re-chequea el estado para desactivar el botón
    let n = 0;
    const iv = setInterval(() => {
      n++;
      const m = checkCompleted();
      if (m[ruleId]) { setCompleted(prev => Object.assign({}, prev, m)); clearInterval(iv); }
      if (n >= 16) clearInterval(iv);
    }, 400);
  }

  return /*#__PURE__*/React.createElement("section", {
    className: "section earn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Cómo"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "ganar puntos"))), /*#__PURE__*/React.createElement("div", {
    className: "earn__grid"
  }, acts.map((a, i) => {
    const isDone = a.ruleId && completed[a.ruleId];
    return /*#__PURE__*/React.createElement(Reveal, {
      key: i,
      className: "earn__row" + (isDone ? ' earn__row--done' : ''),
      delay: i % 3 + 1
    }, /*#__PURE__*/React.createElement("div", {
      className: "earn__icon"
    }, a.icon), /*#__PURE__*/React.createElement("div", {
      className: "earn__copy"
    }, /*#__PURE__*/React.createElement("div", {
      className: "earn__title"
    }, a.title), /*#__PURE__*/React.createElement("div", {
      className: "earn__sub"
    }, a.sub)),
      a.ruleId
        ? (!D.loggedIn
            ? /*#__PURE__*/React.createElement("button", {
                className: "earn__mission-btn earn__mission-btn--disabled",
                disabled: true,
                title: "Inicia sesión para participar"
              }, "Completar +", a.pts)
            : (isDone
                ? /*#__PURE__*/React.createElement("div", { className: "earn__done" }, "✓ Completado")
                : /*#__PURE__*/React.createElement("button", {
                    className: "earn__mission-btn",
                    onClick: () => completeRule(a.ruleId, a.url)
                  }, "Completar +", a.pts)))
        : a.action === 'referir'
          ? (!D.loggedIn
              ? /*#__PURE__*/React.createElement("button", {
                  className: "earn__mission-btn earn__mission-btn--disabled",
                  disabled: true,
                  title: "Inicia sesión para participar"
                }, a.cta, " →")
              : /*#__PURE__*/React.createElement("button", {
                  className: "earn__mission-btn earn__mission-btn--alt",
                  onClick: () => doAction(a.action)
                }, a.cta, " →"))
          : a.action === 'cart'
            ? /*#__PURE__*/React.createElement("button", {
                className: "earn__mission-btn earn__mission-btn--alt",
                onClick: () => doAction(a.action)
              }, a.cta, " →")
            : a.birthday
              ? (!D.loggedIn
                  ? /*#__PURE__*/React.createElement("button", {
                      className: "earn__mission-btn earn__mission-btn--disabled",
                      disabled: true,
                      title: "Inicia sesión para participar"
                    }, "Agregar fecha")
                  : (bdaySaved
                      ? /*#__PURE__*/React.createElement("div", { className: "earn__done" }, "✓ Guardado")
                      : /*#__PURE__*/React.createElement("div", { className: "earn__bday" },
                          /*#__PURE__*/React.createElement("input", {
                            type: "date",
                            className: "earn__bday-input",
                            value: bdayVal,
                            onChange: e => setBdayVal(e.target.value)
                          }),
                          /*#__PURE__*/React.createElement("button", {
                            className: "earn__mission-btn",
                            onClick: saveBirthday
                          }, "Guardar"))))
              : /*#__PURE__*/React.createElement("div", {
                  className: "earn__points"
                }, "+", a.pts, /*#__PURE__*/React.createElement("small", null, a.unit)));
  })),
  /*#__PURE__*/React.createElement("div", {
    "data-lion-rules-list": "",
    style: { visibility: 'hidden', height: 0, overflow: 'hidden', position: 'absolute', left: '-9999px' }
  })));
}

// ── VALOR DE PUNTOS ──────────────────────────────────────────
function Value() {
  const rows = [{
    pts: '200.000 PTS',
    off: '$10.000 OFF'
  }, {
    pts: '300.000 PTS',
    off: '10% OFF'
  }, {
    pts: '500.000 PTS',
    off: '$25.000 OFF'
  }, {
    pts: '700.000 PTS',
    off: '$35.000 OFF'
  }, {
    pts: '600.000 PTS',
    off: '20% OFF'
  }, {
    pts: '1.000.000 PTS',
    off: '$50.000 OFF'
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "El valor"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "de tus puntos")), /*#__PURE__*/React.createElement(Reveal, {
    as: "p"
  }, "Tus puntos se convierten directamente en descuento al canjear.")), /*#__PURE__*/React.createElement(Reveal, {
    className: "value__table"
  }, rows.map((r, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "value__row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pts"
  }, r.pts), /*#__PURE__*/React.createElement("span", {
    className: "eq"
  }, "="), /*#__PURE__*/React.createElement("span", {
    className: "off"
  }, r.off)))), /*#__PURE__*/React.createElement(Reveal, {
    as: "div",
    className: "value__note"
  }, "CANJE M\xCDNIMO DESDE 200.000 PUNTOS \xB7 UN C\xD3DIGO POR COMPRA")));
}

// ── UPSELL GOLD ──────────────────────────────────────────────
function Upsell() {
  return /*#__PURE__*/React.createElement("section", {
    className: "upsell"
  }, /*#__PURE__*/React.createElement("div", {
    className: "upsell__inner"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "pill upsell__pill"
  }, /*#__PURE__*/React.createElement(Sparkle, null), "Exclusivo Oro", /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    className: "upsell__h"
  }, "Sube a ", /*#__PURE__*/React.createElement("span", {
    className: "gold"
  }, "Oro"), /*#__PURE__*/React.createElement("br", null), "y desbloquea", /*#__PURE__*/React.createElement("br", null), "recompensas ", /*#__PURE__*/React.createElement("em", null, "exclusivas")), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    className: "upsell__sub"
  }, "Llega a $800.000 COP en compras y accede a recompensas premium exclusivas, 660.000 puntos en tu cumpleaños y un bono de 330.000 puntos al alcanzar Oro."), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("a", {
    href: "#niveles",
    className: "btn btn--outline-light"
  }, "Ver beneficios ", /*#__PURE__*/React.createElement(ArrowR, null)))));
}

// ── CATÁLOGO DE CANJE ────────────────────────────────────────
const REWARDS_DEF = [{
  kind: 'discount',
  off: '10.000',
  unit: 'descuento',
  pts: 200000,
  min: 60000,
  tier: 'BRONZE',
  order: 1,
  llRewardId: ''
}, {
  kind: 'percent',
  off: '10%',
  unit: 'descuento',
  pts: 300000,
  min: 100000,
  tier: 'BRONZE',
  order: 2,
  llRewardId: ''
}, {
  kind: 'discount',
  off: '25.000',
  unit: 'descuento',
  pts: 500000,
  min: 120000,
  tier: 'BRONZE',
  order: 3,
  llRewardId: ''
}, {
  kind: 'discount',
  off: '35.000',
  unit: 'descuento',
  pts: 700000,
  min: 160000,
  tier: 'SILVER',
  order: 4,
  llRewardId: ''
}, {
  kind: 'percent',
  off: '20%',
  unit: 'descuento',
  pts: 600000,
  min: 150000,
  tier: 'GOLD',
  order: 5,
  llRewardId: ''
}, {
  kind: 'discount',
  off: '50.000',
  unit: 'descuento',
  pts: 1000000,
  min: 200000,
  order: 6,
  tier: 'GOLD',
  llRewardId: ''
}];
const TIER_RANK = {
  BRONZE: 0,
  SILVER: 1,
  GOLD: 2
};
const TIER_ES = { BRONZE: 'BRONCE', SILVER: 'PLATA', GOLD: 'ORO' };
const TIER_EN = { BRONCE: 'BRONZE', PLATA: 'SILVER', ORO: 'GOLD' };
function tEN(t) { t = String(t || '').toUpperCase(); return TIER_EN[t] || t; }
function tES(t) { t = tEN(t); return TIER_ES[t] || t; }
function Catalog({
  pts,
  onOpenNative
}) {
  const [tab, setTab] = uS('TODO');
  const [showNative, setShowNative] = uS(false);
  const [liveMap, setLiveMap] = uS({});

  // Auto-sincroniza con LoyaltyLion: lee ID + puntos VIVOS de cada recompensa.
  // Empareja por etiqueta (no por ID), así nunca se rompe al re-precificar en LL.
  uE(function () {
    function defKey(kind, off) {
      if (kind === 'ship') return 'ship';
      if (kind === 'percent') return 'p' + parseInt(String(off).replace(/[^\d]/g, ''), 10);
      return 'd' + parseInt(String(off).replace(/[^\d]/g, ''), 10);
    }
    function parseLL(text) {
      var key = null, pts = null, min = null;
      var pm = text.match(/([\d.,]+)\s*puntos/i);
      if (pm) pts = parseInt(pm[1].replace(/[.,]/g, ''), 10);
      var dm = text.match(/\$\s*([\d.,]+)\s*discount/i);
      var perc = text.match(/(\d+)\s*%/);
      if (dm) key = 'd' + parseInt(dm[1].replace(/[.,]/g, ''), 10);
      else if (perc) key = 'p' + parseInt(perc[1], 10);
      else if (/env[ií]o|gratuit|free\s*ship/i.test(text)) key = 'ship';
      // Intenta leer el mínimo de compra si LoyaltyLion lo expone en el texto
      var mm = text.match(/(?:m[ií]nim[oa]|minimum|gasta[r]?|spend)[^$%]*\$\s*([\d.,]+)/i);
      if (mm) { var mv = parseInt(mm[1].replace(/[.,]/g, ''), 10); if (mv > 0) min = mv; }
      return { key: key, pts: pts, min: min };
    }
    function scan() {
      var items = document.querySelectorAll('[data-lion-rewards-list] [data-reward-id]');
      if (!items.length) return false;
      var map = {};
      items.forEach(function (it) {
        var id = it.getAttribute('data-reward-id');
        var p = parseLL((it.textContent || '').replace(/\s+/g, ' '));
        if (p.key && id) map[p.key] = { id: id, pts: p.pts, min: p.min };
      });
      if (Object.keys(map).length) { setLiveMap(map); return true; }
      return false;
    }
    var n = 0;
    var iv = setInterval(function () {
      n++;
      try { window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.refresh && window.loyaltylion.ui.refresh(); } catch (e) {}
      if (scan() || n >= 20) clearInterval(iv);
    }, 600);
    // expone helper para el render
    Catalog._defKey = defKey;
    return function () { clearInterval(iv); };
  }, []);

  // Cuando el panel se abre, fuerza re-scan del SDK de LoyaltyLion
  uE(function() {
    if (!showNative) return;
    function tryLLRefresh() {
      try {
        if (window.loyaltylion) {
          if (window.loyaltylion.ui) {
            window.loyaltylion.ui.refresh && window.loyaltylion.ui.refresh();
            window.loyaltylion.ui.render && window.loyaltylion.ui.render();
          }
          window.loyaltylion.refresh && window.loyaltylion.refresh();
          window.loyaltylion.init && window.loyaltylion.init();
        }
        if (window.lion) {
          window.lion.refresh && window.lion.refresh();
          if (window.lion.ui) {
            window.lion.ui.refresh && window.lion.ui.refresh();
          }
        }
        // Re-scan by dispatching a DOM event that LL might listen for
        var el = document.querySelector('[data-lion-rewards-list]');
        if (el) { el.dispatchEvent(new Event('lion:refresh', {bubbles:true})); }
      } catch(e) {}
    }
    tryLLRefresh();
    var t1 = setTimeout(tryLLRefresh, 400);
    var t2 = setTimeout(tryLLRefresh, 1200);

    // Interceptar window.open → redirigir en misma pestaña
    var origOpen = window.open;
    window.open = function(url, target, features) {
      if (url && String(url).length > 1) { window.location.href = url; return null; }
      return origOpen.apply(window, arguments);
    };

    // Interceptar links target="_blank" dentro del panel
    function interceptLinks(e) {
      var panel = document.getElementById('jdc-ll-panel');
      if (!panel || !panel.contains(e.target)) return;
      var a = e.target.closest && e.target.closest('a');
      if (a && a.href && (a.target === '_blank' || a.target === 'blank')) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = a.href;
      }
    }
    document.addEventListener('click', interceptLinks, true);

    return function() {
      clearTimeout(t1); clearTimeout(t2);
      window.open = origOpen;
      document.removeEventListener('click', interceptLinks, true);
    };
  }, [showNative]);

  const myTierRank = TIER_RANK[tEN(D.tier || 'BRONZE')] || 0;
  function keyOf(r) {
    if (r.kind === 'ship') return 'ship';
    if (r.kind === 'percent') return 'p' + parseInt(String(r.off).replace(/[^\d]/g, ''), 10);
    return 'd' + parseInt(String(r.off).replace(/[^\d]/g, ''), 10);
  }
  // Metadatos curados (icono/tier/etiqueta) indexados por clave
  const META = {};
  REWARDS_DEF.forEach(r => { META[keyOf(r)] = r; });
  function metaFor(key) {
    if (META[key]) return META[key];
    if (key === 'ship') return { kind: 'ship', off: 'Envío', unit: 'gratis', tier: 'BRONZE' };
    if (key.charAt(0) === 'p') return { kind: 'percent', off: key.slice(1) + '%', unit: 'descuento', tier: 'BRONZE' };
    const n = parseInt(key.slice(1), 10) || 0;
    return { kind: 'discount', off: n.toLocaleString('es-CO'), unit: 'descuento', tier: 'BRONZE' };
  }
  const liveKeys = Object.keys(liveMap);
  let rewards;
  if (liveKeys.length) {
    // Catálogo 100% dinámico desde LoyaltyLion: solo existe lo que existe en LL
    rewards = liveKeys.map(key => {
      const live = liveMap[key];
      const m = metaFor(key);
      const tier = m.tier || 'BRONZE';
      return {
        kind: m.kind, off: m.off, unit: m.unit, tier: tier, min: (live.min || m.min || 0),
        pts: live.pts, llRewardId: live.id, order: m.order,
        tierLocked: TIER_RANK[tier] > myTierRank,
        ok: pts >= live.pts && TIER_RANK[tier] <= myTierRank
      };
    }).sort((a, b) => (a.order ?? (1000 + a.pts)) - (b.order ?? (1000 + b.pts)));
  } else {
    // Fallback mientras LoyaltyLion termina de cargar
    rewards = REWARDS_DEF.map(r => ({
      ...r,
      tierLocked: TIER_RANK[r.tier] > myTierRank,
      ok: pts >= r.pts && TIER_RANK[r.tier] <= myTierRank
    }));
  }
  const filtered = tab === 'TODO' ? rewards : tab === 'PUEDO' ? rewards.filter(r => r.ok) : rewards.filter(r => !r.ok);
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: "canjear",
    style: {
      background: 'var(--bg-soft)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "catalog__head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "catalog__title"
  }, /*#__PURE__*/React.createElement("small", null, "RECOMPENSAS"), "Canjee", /*#__PURE__*/React.createElement("br", null), "tus puntos"), /*#__PURE__*/React.createElement("div", {
    className: "catalog__tabs"
  }, ['TODO', 'PUEDO', 'POR DESBLOQUEAR'].map(t => /*#__PURE__*/React.createElement("button", {
    key: t,
    className: `catalog__tab ${tab === t ? 'catalog__tab--active' : ''}`,
    onClick: () => setTab(t)
  }, t === 'PUEDO' ? 'Puedo canjear' : t === 'TODO' ? 'Todo' : 'Por desbloquear')))), !D.loggedIn && /*#__PURE__*/React.createElement("div", {
    className: "reward__login-cta"
  }, /*#__PURE__*/React.createElement("strong", null, "\xBFYa es miembro del club?"), " ", /*#__PURE__*/React.createElement("a", {
    href: D.loginUrl
  }, "Inicia sesi\xF3n"), " pa ver los premios disponibles con sus puntos. \xBF A\xFAn no tiene cuenta? ", /*#__PURE__*/React.createElement("a", {
    href: D.registerUrl
  }, "\xDAnete gratis"), " y recibe 80.000 puntos de bienvenida."), /*#__PURE__*/React.createElement("div", {
    className: "catalog__grid"
  }, filtered.map((r, i) => {
    const locked = !r.ok;
    const statusText = r.tierLocked ? `NIVEL ${tES(r.tier)}` : r.ok ? 'DISPONIBLE' : `FALTAN ${(r.pts - pts).toLocaleString('es-CO')} PTS`;
    return /*#__PURE__*/React.createElement(Reveal, {
      key: i,
      className: `reward ${locked ? 'reward--locked' : ''}`,
      delay: i % 4 + 1
    }, /*#__PURE__*/React.createElement("div", {
      className: "reward__head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "reward__icon"
    }, r.kind === 'ship' ? /*#__PURE__*/React.createElement(IconTruck, null) : /*#__PURE__*/React.createElement(IconTag, null)), /*#__PURE__*/React.createElement("div", {
      className: `reward__status ${r.ok ? 'reward__status--ok' : 'reward__status--locked'}`
    }, locked && /*#__PURE__*/React.createElement(IconLock, null), " ", statusText)), /*#__PURE__*/React.createElement("div", {
      className: "reward__title"
    }, r.kind === 'discount' && /*#__PURE__*/React.createElement(React.Fragment, null, "$", r.off, /*#__PURE__*/React.createElement("small", null, r.unit)), r.kind === 'percent' && /*#__PURE__*/React.createElement(React.Fragment, null, r.off, /*#__PURE__*/React.createElement("small", null, r.unit)), r.kind === 'ship' && /*#__PURE__*/React.createElement(React.Fragment, null, r.off, /*#__PURE__*/React.createElement("small", null, r.unit))), /*#__PURE__*/React.createElement("div", {
      className: "reward__cost"
    }, /*#__PURE__*/React.createElement("b", null, r.pts.toLocaleString('es-CO'), " PTS"), /*#__PURE__*/React.createElement("span", {
      className: "reward__tier"
    }, "NIVEL ", tES(r.tier))), r.min ? /*#__PURE__*/React.createElement("div", {
      className: "reward__min",
      style: { fontSize: '12px', opacity: 0.65, marginTop: '6px' }
    }, "M\xEDn. de compra $", r.min.toLocaleString('es-CO')) : null, D.loggedIn && /*#__PURE__*/React.createElement("div", {
      className: "reward__cta"
    }, /*#__PURE__*/React.createElement("button", {
      className: "reward__cta-btn",
      disabled: locked,
      onClick: () => {
        if (locked) return;
        // Canje directo. El id de LoyaltyLion se resuelve EN CADA intento:
        // si el cliente hace clic antes de que la lista de LL renderice, el
        // fallback deja llRewardId vacio y antes reintentabamos con un id
        // vacio para siempre, dejando el panel abierto.
        var idPreferido = r.llRewardId;
        var ptsBuscados = String(r.pts || '');

        function buscarItem() {
          var items = document.querySelectorAll('[data-lion-rewards-list] .lion-reward-item[data-reward-id]');
          if (!items.length) return null;
          // 1) por id exacto, si ya lo conocemos
          if (idPreferido) {
            for (var i = 0; i < items.length; i++) {
              if (items[i].getAttribute('data-reward-id') === String(idPreferido)) return items[i];
            }
          }
          // 2) por costo en puntos, que si conocemos siempre
          if (ptsBuscados) {
            for (var k = 0; k < items.length; k++) {
              var digitos = (items[k].textContent || '').replace(/[^0-9]/g, '');
              if (digitos.indexOf(ptsBuscados) !== -1) {
                idPreferido = items[k].getAttribute('data-reward-id');
                return items[k];
              }
            }
          }
          return null;
        }

        function canjear() {
          var item = buscarItem();
          if (!item) return false;
          var btn = item.querySelector('button[data-testid="redeem-reward-button"]')
                 || item.querySelector('button.lion-action-button')
                 || item.querySelector('button');
          if (!btn) return false;
          btn.click();
          return true;
        }

        if (!canjear()) {
          // Reintentar en silencio ~3 s antes de mostrarle el panel al cliente
          var tries = 0;
          var iv = setInterval(function () {
            tries++;
            if (canjear()) { clearInterval(iv); return; }
            if (tries >= 20) {
              clearInterval(iv);
              setShowNative(true);
              setTimeout(function () {
                if (canjear()) return;
                var panel = document.getElementById('jdc-ll-panel');
                if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 600);
            }
          }, 150);
        }
      }
    }, r.ok ? 'Canjear ahora' : locked ? 'Bloqueada' : 'Puntos insuficientes')));
  })), /*#__PURE__*/React.createElement("p", {
    className: "catalog__note",
    style: { textAlign: 'center', fontSize: '13px', opacity: .7, marginTop: '18px', lineHeight: 1.5 }
  }, "Los puntos vencen a los 12 meses sin actividad (cualquier compra reinicia el contador). Al canjear, tu c\xF3digo de descuento tiene 90 d\xEDas para usarse y se aplica en el checkout. Solo se puede usar un código del club por compra."), D.loggedIn && /*#__PURE__*/React.createElement("div", {
    id: "jdc-ll-panel",
    className: "jdc-v2-ll-native" + (showNative ? ' jdc-v2-ll-native--open' : ''),
    style: showNative ? {} : { visibility: 'hidden', height: 0, overflow: 'hidden', margin: 0, padding: 0, border: 'none' }
  }, /*#__PURE__*/React.createElement("div", {
    className: "jdc-v2-ll-heading"
  }, "Elige tu recompensa y genera el c\xF3digo de descuento:"), /*#__PURE__*/React.createElement("div", {
    "data-lion-rewards-list": ""
  }), /*#__PURE__*/React.createElement("button", {
    className: "jdc-v2-ll-toggle",
    style: { marginTop: '16px' },
    onClick: () => setShowNative(false)
  }, "Cerrar"))));
}

// ── NIVELES VIP ──────────────────────────────────────────────
const TIERS_DATA = [{
  key: 'bronze',
  name: 'Bronce',
  cardNum: '0001 ···· ···· ···',
  req: '$0 – $300.000 COP',
  bullets: [{
    t: 'Gana puntos con cada compra',
    muted: false
  }, {
    t: 'Bono de bienvenida 80.000 pts',
    muted: false
  }, {
    t: '200.000 pts en tu cumpleaños',
    muted: false
  }, {
    t: 'Acceso al catálogo de canje',
    muted: false
  }, {
    t: '330.000 pts en tu cumpleaños (Plata)',
    muted: true
  }],
  benefits: ['Gana puntos con cada compra', '80.000 puntos de bienvenida al unirte', '200.000 puntos en tu cumpleaños', 'Acceso al catálogo de canje de recompensas']
}, {
  key: 'silver',
  name: 'Plata',
  cardNum: '0002 ···· ···· ···',
  req: '$300.000 – $800.000 COP',
  bullets: [{
    t: 'Todo lo de Bronce',
    muted: false
  }, {
    t: '1,5x puntos en cada compra',
    muted: false
  }, {
    t: '330.000 pts en tu cumpleaños',
    muted: false
  }, {
    t: 'Bono de 200.000 pts al llegar a Plata',
    muted: false
  }, {
    t: 'Recompensas exclusivas Plata+',
    muted: false
  }, {
    t: 'Más beneficios en Oro',
    muted: true
  }],
  benefits: ['Todos los beneficios de Bronce', '1,5x puntos en cada compra', '330.000 puntos en tu cumpleaños', 'Bono de 200.000 puntos al alcanzar Plata (canjea de inmediato)', 'Envío gratis canjeable, exclusivo Plata+']
}, {
  key: 'gold',
  name: 'Oro',
  cardNum: '0003 ···· ···· ···',
  req: '$800.000+ COP',
  bullets: [{
    t: 'Todo lo de Plata',
    muted: false
  }, {
    t: '2x puntos en cada compra',
    muted: false
  }, {
    t: '660.000 pts en tu cumpleaños',
    muted: false
  }, {
    t: 'Bono de 330.000 pts al llegar a Oro',
    muted: false
  }, {
    t: 'Recompensas premium exclusivas',
    muted: false
  }],
  benefits: ['Todos los beneficios de Plata', '2x puntos en cada compra', '660.000 puntos en tu cumpleaños', 'Bono de 330.000 puntos la primera vez que alcanzas Oro', 'Recompensas premium exclusivas: 20% off y $50.000 off solo para Oro']
}];
function TierCard({
  t
}) {
  const [flipped, setFlipped] = uS(false);
  const isCurrentTier = (D.tier || 'BRONZE') === t.key.toUpperCase() || tEN(D.tier || 'BRONZE') === t.key.toUpperCase();
  return /*#__PURE__*/React.createElement(Reveal, {
    className: `tier tier--${t.key}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `tier__card-host ${flipped ? 'is-flipped' : ''}`,
    onClick: () => setFlipped(v => !v),
    role: "button",
    tabIndex: 0,
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setFlipped(v => !v);
      }
    },
    "aria-label": `Tarjeta ${t.name} — toca para ver beneficios`
  }, isCurrentTier && /*#__PURE__*/React.createElement("div", {
    className: "tier__current"
  }, "Tu nivel actual"), /*#__PURE__*/React.createElement("div", {
    className: "tier__card-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__face tier__face--front"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__face-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__card-head"
  }, /*#__PURE__*/React.createElement("span", null, "jdc \xB7 club"), /*#__PURE__*/React.createElement("span", null, t.key === 'bronze' ? 'ENTRY' : t.key === 'silver' ? 'MEMBER' : 'TOP TIER')), /*#__PURE__*/React.createElement("div", {
    className: "tier__card-chip"
  }), /*#__PURE__*/React.createElement("div", {
    className: "tier__card-name"
  }, t.name), /*#__PURE__*/React.createElement("div", {
    className: "tier__card-number"
  }, t.cardNum), /*#__PURE__*/React.createElement("div", {
    className: "tier__card-foot"
  }, /*#__PURE__*/React.createElement("span", null, "MIEMBRO \xB7 MDE"), /*#__PURE__*/React.createElement("span", null, "MMXXIV")))), /*#__PURE__*/React.createElement("div", {
    className: "tier__face tier__face--back"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__face-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__back-title"
  }, "Beneficios \xB7 ", t.name), /*#__PURE__*/React.createElement("ul", {
    className: "tier__back-list"
  }, t.benefits.map((b, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, b))), /*#__PURE__*/React.createElement("div", {
    className: "tier__back-foot"
  }, /*#__PURE__*/React.createElement("span", null, "JDC \xB7 MMXXIV"), /*#__PURE__*/React.createElement("span", null, t.cardNum.split(' ')[0])))))), /*#__PURE__*/React.createElement("div", {
    className: "tier__hint"
  }, "\u21BB Toca para ver beneficios")), /*#__PURE__*/React.createElement("div", {
    className: "tier__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier__req"
  }, t.req), /*#__PURE__*/React.createElement("ul", {
    className: "tier__bullets"
  }, t.bullets.map((b, j) => /*#__PURE__*/React.createElement("li", {
    key: j,
    className: b.muted ? 'muted' : ''
  }, /*#__PURE__*/React.createElement(IconCheck, null), /*#__PURE__*/React.createElement("span", null, b.t))))));
}
function Tiers() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: "niveles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Niveles"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "VIP")), /*#__PURE__*/React.createElement(Reveal, {
    as: "p"
  }, "Avanza por los tres niveles del CLUB JDC y desbloquea beneficios cada vez mejores. Toca cualquier tarjeta para ver los detalles.")), /*#__PURE__*/React.createElement("div", {
    className: "tiers__grid"
  }, TIERS_DATA.map(t => /*#__PURE__*/React.createElement(TierCard, {
    key: t.key,
    t: t
  })))));
}

// ── REFERIDOS ────────────────────────────────────────────────
function Refer({
  referralUrl
}) {
  const [copied, setCopied] = uS(false);
  const displayUrl = referralUrl || (D.loggedIn ? 'Cargando tu enlace...' : 'Inicia sesión para ver tu link');
  const copy = () => {
    if (!referralUrl) return;
    navigator.clipboard?.writeText(referralUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "refer",
    id: "referir"
  }, /*#__PURE__*/React.createElement("div", {
    className: "refer__inner"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "pill"
  }, /*#__PURE__*/React.createElement(Sparkle, null), "Refiere y gana", /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    className: "refer__h"
  }, "Tu amigo recibe un descuento.", /*#__PURE__*/React.createElement("br", null), "Tú ganas ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "puntos.")), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    className: "refer__sub"
  }, "Comparte tu enlace personal. Ganas 330.000 puntos cuando tu amigo haga su primera compra de $100.000 o m\xE1s."), /*#__PURE__*/React.createElement(Reveal, {
    className: "refer__link"
  }, /*#__PURE__*/React.createElement("input", {
    className: "refer__link-input",
    value: displayUrl,
    readOnly: true
  }), /*#__PURE__*/React.createElement("button", {
    className: "refer__link-btn",
    onClick: copy,
    disabled: !referralUrl
  }, /*#__PURE__*/React.createElement(IconCopy, null), copied ? '\xA1Listo! ✓' : 'Copiar')), /*#__PURE__*/React.createElement("a", {
    className: "refer__wa-btn",
    href: referralUrl ? ('https://wa.me/?text=' + encodeURIComponent('Descubre JDC, moda premium colombiana 🔥 Usa mi link y obt\xE9n 10% de descuento en tu primera compra: ' + referralUrl)) : '#',
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function(e){ if(!referralUrl) e.preventDefault(); },
    style: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', background: '#25D366', color: '#fff', textDecoration: 'none', fontWeight: 'bold', padding: '14px 28px', borderRadius: '10px', marginTop: '14px', fontSize: '15px' }
  }, "💬 Compartir por WhatsApp"), /*#__PURE__*/React.createElement(Reveal, {
    className: "refer__stats"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "330.000"), "PUNTOS POR REFERIDO"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "10", /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 20,
      opacity: 0.6
    }
  }, "%")), "DESCUENTO PARA TU AMIGO"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "\u221E"), "SIN L\xCDMITE DE REFERIDOS"))));
}

// ── FAQ ───────────────────────────────────────────────────────
const FAQ_DATA = [{
  q: '¿Cómo funciona el Club JDC?',
  a: 'El Club JDC es nuestro programa de fidelización, hecho con mucho amor desde Medellín. Por cada compra acumula puntazos que puede canjear por descuentos exclusivos. Va subiendo de nivel a medida que nos elige más.'
}, {
  q: '¿Cómo me inscribo?',
  a: 'Es automático y completamente gratis, parce. Al crear su cuentica en jdchouse.com recibe 80.000 puntos de bienvenida y entra directo al nivel Bronce. De una.'
}, {
  q: '¿Cómo acumulo puntos?',
  a: '1 punto por cada $1 COP que gaste en compras (1,5x en Plata y 2x en Oro). Suma extra con su cumpleaños (desde 200.000 puntos), trayendo parces (330.000 por cada amigo que haga su primera compra de $100.000 o más), reseñas con foto (40.000) y siguiéndonos en redes (5.000).'
}, {
  q: '¿Cuáles son los niveles?',
  a: 'Hay tres niveles: Bronce (desde $0), Plata (desde $300.000) y Oro (desde $800.000). Ganas desde 1 punto por cada peso (1,5x en Plata y 2x en Oro); al subir de nivel desbloquea más beneficios, como mayor descuento de cumpleaños y un bono de bienvenida al alcanzar Oro.'
}, {
  q: '¿Cuándo se acreditan mis puntos?',
  a: 'Tus puntos quedan pendientes y se acreditan 21 días después de tu compra. Ese plazo nos permite cubrir cambios o devoluciones; una vez pasa, los puntos quedan disponibles para canjear. Pilas con eso.'
}, {
  q: '¿Los puntos y las recompensas caducan?',
  a: 'Sus puntazos son válidos durante 12 meses desde la última actividad en su cuenta: cualquier compra, canje o parce referido reinicia el contador. Y cuando canjea una recompensa, el código de descuento tiene 90 días para usarse. Pilas con eso, parce.'
}, {
  q: '¿Cómo uso el código de mi recompensa?',
  a: 'Al canjear recibe un código que se aplica en el checkout, y tiene 90 días para usarlo. Solo se puede usar un código del club por compra, y no se combina con otros códigos o promociones que ya estén aplicados al pedido. Si al momento de pagar no le suma, escríbanos y lo revisamos de una.'
}];
function FAQ() {
  const [open, setOpen] = uS(0);
  const FAQ_ITEMS = FAQ_DATA;
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      background: 'var(--bg-soft)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Preguntas"), " ", /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "frecuentes"))), /*#__PURE__*/React.createElement(Reveal, {
    className: "faq__list"
  }, FAQ_ITEMS.map((f, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: `faq__item ${open === i ? 'faq__item--open' : ''}`
  }, /*#__PURE__*/React.createElement("button", {
    className: "faq__q",
    onClick: () => setOpen(open === i ? -1 : i)
  }, /*#__PURE__*/React.createElement("span", {
    className: "faq__q-num"
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", {
    className: "faq__q-text"
  }, f.q), /*#__PURE__*/React.createElement("span", {
    className: "faq__q-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "faq__a"
  }, /*#__PURE__*/React.createElement("div", {
    className: "faq__a-inner"
  }, f.a)))))));
}

// ── APP ROOT ─────────────────────────────────────────────────
function ClaimedRewards() {
  if (!D.loggedIn) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "section claimed",
    id: "cupones"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Tus "), /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "cupones"))), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    className: "claimed__sub"
  }, "Aquí encuentras los códigos de las recompensas que ya canjeaste."), /*#__PURE__*/React.createElement("div", {
    className: "claimed__list",
    "data-lion-claimed-rewards-list": "",
    "data-hide-void": "true",
    "data-hide-expired": "true"
  })));
}
function TierProgressLL() {
  if (!D.loggedIn) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "tierprogress container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tierprogress__inner",
    "data-lion-tier-progress": "multi"
  }));
}
function History() {
  if (!D.loggedIn) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "section history",
    id: "historial",
    style: { background: 'var(--bg-soft)' }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section__head"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sparkle-row"
  }, /*#__PURE__*/React.createElement(Sparkle, null)), /*#__PURE__*/React.createElement(Reveal, {
    as: "h2"
  }, /*#__PURE__*/React.createElement("span", null, "Tu "), /*#__PURE__*/React.createElement("span", {
    className: "accent"
  }, "historial de puntos"))), /*#__PURE__*/React.createElement("div", {
    className: "history__feed",
    "data-lion-history-table": ""
  })));
}
function esES(raiz) {
  if (!raiz) return;
  const mil = n => Number(n).toLocaleString('es-CO');
  const it = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
  const pend = [];
  while (it.nextNode()) pend.push(it.currentNode);
  pend.forEach(n => {
    let t = n.nodeValue;
    if (!t || !/discount/i.test(t)) return;
    const orig = t;
    t = t.replace(/\$\s*([\d.,]+)\s*discount/gi,
      (m, num) => '$' + mil(String(num).replace(/[.,]/g, '')) + ' de descuento');
    t = t.replace(/([\d.,]+)\s*%\s*discount/gi, (m, num) => num + '% de descuento');
    t = t.replace(/discount/gi, 'descuento');
    if (t !== orig) n.nodeValue = t;
  });
}
function RewardNotif({ pts }) {
  // La caja de LoyaltyLion vive SIEMPRE en la misma posicion del arbol.
  // Si cambia de padre, React la desmonta, LoyaltyLion pierde lo inyectado
  // y hay que esperar a que lo vuelva a pintar (eso causaba la demora).
  const [tieneCupon, setTieneCupon] = uS(null);
  const boxRef = React.useRef(null);
  uE(() => {
    if (!D.loggedIn) return;
    let visto = false;
    function revisar() {
      const el = boxRef.current;
      if (!el) return;
      esES(el);                       // traducir en CADA pasada, no solo la primera
      const lleno = el.children.length > 0 && el.textContent.trim().length > 0;
      if (lleno && !visto) { visto = true; setTieneCupon(true); }
    }
    const iv = setInterval(revisar, 250);
    const to = setTimeout(() => {
      clearInterval(iv);
      if (!visto) setTieneCupon(false);
    }, 12000);
    const obs = new MutationObserver(revisar);
    if (boxRef.current) obs.observe(boxRef.current, { childList: true, subtree: true, characterData: true });
    revisar();
    return () => { clearInterval(iv); clearTimeout(to); obs.disconnect(); };
  }, []);

  const asequibles = REWARDS_DEF.filter(r => pts >= r.pts).sort((a, b) => b.pts - a.pts);
  const mejor = asequibles[0];
  const siguiente = REWARDS_DEF.filter(r => r.pts > pts).sort((a, b) => a.pts - b.pts)[0];

  const conCupon = tieneCupon === true;
  const conPuntos = tieneCupon === false && !!mejor;
  const visible = D.loggedIn && (conCupon || conPuntos);

  let texto = null, accion = null;
  if (conCupon) {
    texto = [
      /*#__PURE__*/React.createElement("span", { className: "big", key: "t" }, "Tienes un descuento sin usar"),
      " Se aplica en el checkout y tienes 90 días para usarlo. Solo se puede usar un código del club por compra."
    ];
    accion = /*#__PURE__*/React.createElement("a", { href: "/collections/all", className: "msg__act" },
      "Ir a comprar ", /*#__PURE__*/React.createElement(ArrowR, null));
  } else if (conPuntos) {
    texto = [
      /*#__PURE__*/React.createElement("span", { className: "big", key: "t" }, "Tienes ", pts.toLocaleString('es-CO'), " puntos sin usar"),
      " Te alcanzan para ",
      /*#__PURE__*/React.createElement("b", { key: "b" }, mejor.off, " de ", mejor.unit),
      siguiente ? ", y con " + (siguiente.pts - pts).toLocaleString('es-CO') + " más llegas a " + siguiente.off : "",
      ". Al canjear recibes un código con 90 días para usarlo."
    ];
    accion = /*#__PURE__*/React.createElement("a", { href: "#canjear", className: "msg__act" },
      "Canjear mis puntos ", /*#__PURE__*/React.createElement(ArrowR, null));
  }

  // estructura estable: la seccion y la caja existen siempre, se oculta con CSS
  return /*#__PURE__*/React.createElement("section", {
    className: visible ? "msg" : "msg msg--oculto"
  },
    visible ? /*#__PURE__*/React.createElement("div", { className: "msg__in" },
      /*#__PURE__*/React.createElement("div", { className: "msg__txt" }, texto),
      accion
    ) : null,
    /*#__PURE__*/React.createElement("div", {
      ref: boxRef,
      "data-lion-claimed-rewards-list": "",
      "data-hide-used": "true",
      "data-hide-void": "true",
      "data-hide-expired": "true",
      className: "msg__ll"
    })
  );
}
function App() {
  const [pts, setPts] = uS(0);
  const [tier, setTier] = uS(D.tier || 'BRONZE');
  const [referralUrl, setReferralUrl] = uS('');
  uE(() => {
    let lastPts = -1;
    let lastRef = '';
    let lastTier = D.tier || 'BRONZE';
    function syncLL() {
      const llEl = document.querySelector('[data-lion-points="approved"]');
      if (llEl) {
        const raw = (llEl.textContent || '').replace(/[^0-9]/g, '');
        const p = parseInt(raw, 10);
        if (!isNaN(p) && p >= 0 && p !== lastPts) { lastPts = p; setPts(p); }
      }
      const refEl = document.querySelector('[data-lion-referral-url]');
      if (refEl) {
        const url = refEl.textContent.trim() || refEl.getAttribute('data-url') || refEl.getAttribute('href') || '';
        if (url && url.length > 5 && url !== lastRef) { lastRef = url; setReferralUrl(url); }
      }
      // Sync tier from LL SDK (wrapped to never break points sync)
      try {
        const llSDKTier = (window.lion && window.lion.customer && window.lion.customer.tier_name)
          ? String(window.lion.customer.tier_name).toUpperCase() : null;
        var llSDKTierN = tEN(llSDKTier);
        if (llSDKTierN && ['BRONZE','SILVER','GOLD'].includes(llSDKTierN) && llSDKTierN !== tEN(lastTier)) {
          lastTier = llSDKTierN; D.tier = llSDKTierN; setTier(llSDKTierN);
        }
      } catch(e) {}
    }

    // Poll every 500ms for 15s — catches LL injecting at any point after mount
    const llInterval = setInterval(syncLL, 500);
    const llStop = setTimeout(() => clearInterval(llInterval), 15000);

    // Also watch childList mutations (LL may replace text nodes)
    const obs = new MutationObserver(syncLL);
    obs.observe(document.body, { childList: true, subtree: true });
    syncLL();
    return () => { obs.disconnect(); clearInterval(llInterval); clearTimeout(llStop); };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment,null,/*#__PURE__*/React.createElement(Hero,{pts}),/*#__PURE__*/React.createElement(RewardNotif,{pts}),/*#__PURE__*/React.createElement(Dashboard,{pts,tier}),/*#__PURE__*/React.createElement(HowTo,null),/*#__PURE__*/React.createElement(Benefits,null),/*#__PURE__*/React.createElement(Earn,null),/*#__PURE__*/React.createElement(Catalog,{pts}),/*#__PURE__*/React.createElement(Upsell,null),/*#__PURE__*/React.createElement(Value,null),/*#__PURE__*/React.createElement(History,null),/*#__PURE__*/React.createElement(TierProgressLL,null),/*#__PURE__*/React.createElement(Tiers,null),/*#__PURE__*/React.createElement(Refer,{referralUrl}),/*#__PURE__*/React.createElement(FAQ,null));
}
ReactDOM.createRoot(document.getElementById('jdc-v2-app')).render(/*#__PURE__*/React.createElement(App, null));